import { render, staticRenderFns } from "./gabung_beberapa_blok.vue?vue&type=template&id=c1da219c&"
import script from "./gabung_beberapa_blok.vue?vue&type=script&lang=js&"
export * from "./gabung_beberapa_blok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports